import { 
  sendLoop,
  sendPause,
  sendPrevious,
  sendResume, 
  sendShuffle, 
  sendSkip 
} from '../function'
import { 
  BiSearch,
  BiAddToQueue,
  BiBlock
} from 'react-icons/bi'
import { 
  RiPlayCircleFill,
  RiPauseCircleFill,
  RiSkipBackFill,
  RiSkipForwardFill,
  RiRepeat2Fill,
  RiShuffleLine,
  RiRepeatOneLine
} from "react-icons/ri";
import { MdQueueMusic } from 'react-icons/md'
import mobile from '../styles/mobile.module.scss'
import panel from '../styles/panel.module.scss'
import { useState } from 'react';
import { motion } from "framer-motion"

function copyText(title: string) {
  navigator.clipboard.writeText(title);
}

const MenuPage = ({ 
  client, 
  playerGuild, 
  current, 
  pause, 
  loop, 
  res, 
  member, 
  user,
  choose,
  queue,
  setRes,
  setChoose
}: any) => {
  const [buttonState, setButtonState] = useState("control")
  const artwork = current ? `${current.thumbnail}` : '/no_music.png'

  async function sendTracks(track: any) {
    setChoose((current: any) => [...current, track.uri])
    if (choose.includes(track.uri)) return
    await client.send(JSON.stringify({ message: "add", guild: playerGuild?.id, user: user?.id, tracks: [track] }))
    await queue.push(track)
  }

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const query = e.target.search.value
    await client.send(JSON.stringify({ message: "search", guild: playerGuild?.id, query: query }))
  };

  function searchClick() {
    client.send(JSON.stringify({ message: "member_status", guild: playerGuild?.id, user: user?.id }))
    setButtonState("search")
  }

  function controlClick() {
    client.send(JSON.stringify({ message: "member_status", guild: playerGuild?.id, user: user?.id }))
    setButtonState("control")
  }

  function queueClick() {
    client.send(JSON.stringify({ message: "member_status", guild: playerGuild?.id, user: user?.id }))
    setButtonState("queue")
  }

  async function removeClick(track: any) {
    await client.send(JSON.stringify({ message: "remove", guild: playerGuild?.id, uri: track.uri }))
  }

  async function removeAllClick() {
    await client.send(JSON.stringify({ message: "destroy", guild: playerGuild?.id }))
  }

  function removeAllSearchClick() {
    setRes(undefined)
    setChoose(undefined)
  }

  return (
    <>
      <div className={mobile.container}>
        <div className={mobile.queue} data-state={buttonState === "queue" ? "true" : "false"}>
          <div className={mobile.mem} data-state={member ? "true" : "false"}>

            <div className={mobile.queue_res} data-state={queue ? "true" : "false"}>
              <div className={mobile.queue_remove_all} onClick={() => removeAllClick()}>
                <p>Remove all tracks in queue</p>
              </div>
              {
                queue && queue.map((t: any) => (
                  <div key={t?.uri} className={mobile.queue_tab} data-color={current && t.uri === current.uri ? "true" : "false"}>

                    <div className={mobile.queue_info}>
                      <p>{t.title}</p>

                      {t.uri === current.uri ? (
                        <motion.img 
                        src='/no_music.png'  
                        alt={t.title}
                        animate={{
                          rotate: 360,
                        }}
                        transition={{ ease: "linear", duration: 20, repeat: Infinity }}/>
                      ) : (
                        <img src='/no_music.png' alt={t.title}/>
                      )}

                    </div>
                    <motion.div whileTap={{ scale: 0.99 }} className={mobile.queue_button} onClick={() => removeClick(t)}>
                      <BiBlock size={40} color="#ffffff" />
                    </motion.div>

                  </div>
                ))
              }

            </div>

            <div className={mobile.search_none} data-state={queue ? "true" : "false"}>
              <BiAddToQueue size={90} color="#ffffff"/>
              <p>No song in queue! Search a song and add to your player queue!</p>
            </div>

          </div>

          <div className={mobile.no_mem} data-state={!member ? "true" : "false"}>
            <MdQueueMusic size={90} color="#ffffff"/>
            <p>To use this feature, you need to enter the voice channel first.</p>
          </div>
        </div>

        <div className={mobile.search} data-state={buttonState === "search" ? "true" : "false"}>
          <div className={mobile.mem} data-state={member ? "true" : "false"}>
            <form className={mobile.search_panel} onSubmit={handleSubmit}>
              <select form-name="source" name="source">
                <option value="soundcloud" selected={false}>
                  SoundCloud
                </option>
                <option value="spotify" selected={true}>
                  Spotify
                </option>
                <option value="nicovideo" selected={true}>
                  NicoVideo
                </option>
                <option value="deezer" selected={true}>
                  Deezer
                </option>
              </select>
              <input form-name="search" type="text" name="search" placeholder="Type here to search!" autoComplete="off"/>
              <input form-name="summit" type="submit" value="Search"/>
            </form>

            <div className={mobile.search_res} data-state={res ? "true" : "false"}>
              <div className={mobile.search_remove_all} onClick={() => removeAllSearchClick()}>
                <p>Remove all tracks in search</p>
              </div>
              {
                res && res.map((t: any) => (
                  <motion.div 
                    whileTap={{ scale: 0.98 }}
                    key={t.uri} 
                    className={mobile.search_choose} 
                    onClick={() => sendTracks(t)} 
                    data-selected={choose ? choose.includes(t.uri) ? "true" : "false" : "false"}>
                    <p>{t.title}</p>
                    <img src='/no_music.png' alt={t.title}/>
                  </motion.div>
                ))
              }

            </div>

            <div className={mobile.search_none} data-state={res ? "true" : "false"}>
              <BiSearch size={90} color="#ffffff"/>
              <p>To search for music, type in the search box and press Search</p>
            </div>
          </div>

          <div className={mobile.no_mem} data-state={!member ? "true" : "false"}>
            <BiSearch size={90} color="#ffffff"/>
            <p>To use this feature, you need to enter the voice channel first.</p>
          </div>
        </div>

        {/* Start Mobile Controller */}
        <motion.div className={mobile.artwork} data-state={buttonState === "control" ? "true" : "false"}>
          {current ? (
            <motion.img 
            src={artwork} 
            className={panel.artwork} 
            alt={`Artwork`}
            animate={{
              rotate: 360,
            }}
            transition={{ ease: "linear", duration: 20, repeat: Infinity }}/>
          ) : (
            <img src={artwork} className={panel.artwork} alt={`Artwork`}/>
          )}
        </motion.div>

        <div className={mobile.bottom}>

          <div className={mobile.title} data-state={buttonState === "control" ? "true" : "false"}>
            <div onClick={() => copyText(current.title || "")}>
              <h1>{current ? current.title : "No tracks playing!"}</h1>
            </div>
          </div>

          <div className={mobile.center_panel} data-state={buttonState === "control" ? "true" : "false"}>
            <div className={mobile.panel}>
              <motion.div whileTap={{ scale: 0.9 }} onClick={() => sendLoop(client, playerGuild, loop)}>
              {
                  loop === "track" ? <RiRepeatOneLine size={40} color="#ffffff"/>
                  : <RiRepeat2Fill size={40} color={loop === "queue" ? "#ffffff" : "#585858"} />
                }
              </motion.div>

              <motion.div whileTap={{ scale: 0.9 }} onClick={() => sendPrevious(client, playerGuild)}>
                  <RiSkipBackFill size={60} color="#ffffff"/>
              </motion.div>

              {
                !pause ? 
                <motion.div whileTap={{ scale: 0.9 }} onClick={() => sendPause(client, playerGuild)}>
                  <RiPauseCircleFill size={70} color="#ffffff"/>
                </motion.div>
                : <motion.div whileTap={{ scale: 0.9 }} onClick={() => sendResume(client, playerGuild)}>
                  <RiPlayCircleFill size={70} color="#ffffff"/>
                </motion.div> 
              }

              <motion.div whileTap={{ scale: 0.9 }} onClick={() => sendSkip(client, playerGuild)}>
                <RiSkipForwardFill size={60} color="#ffffff"/> 
              </motion.div> 

              <motion.div whileTap={{ scale: 0.9 }} onClick={() => sendShuffle(client, playerGuild)}>
                <RiShuffleLine size={40} color="#ffffff" />
              </motion.div>
            </div>

          </div>
          
          <div className={mobile.button_center}>
            <div className={mobile.grid}>
              <motion.div whileTap={{ scale: 0.95 }} className={mobile.button} onClick={() => controlClick()}>
                <p>Controller</p>
              </motion.div>
              <motion.div whileTap={{ scale: 0.95 }} className={mobile.button} onClick={() => searchClick()}>
                <p>Search</p>
              </motion.div>
              <motion.div whileTap={{ scale: 0.95 }} className={mobile.button} onClick={() => queueClick()}>
                <p>Queue</p>
              </motion.div>
            </div>
          </div>


        </div>
        {/* End Mobile Controller */}

      </div>
    </>
  )
}
export default MenuPage